// StatHeader.tsx
import React from 'react';
import { PrismicRichText, JSXMapSerializer } from '@prismicio/react';
import {
  RichTextField, // Potentially other Prismic types if needed
} from '@prismicio/types';

import StyleCharsRecursive from './StyleCharsRecursive';

interface StatHeaderProps {
  field: RichTextField | null | undefined;
  className?: string;
}

const StatHeader: React.FC<StatHeaderProps> = ({ field, className }) => {
  // Define the Tailwind classes you want to apply to '+' or '%'
  const specialCharStyles: string = 'text-[#03BF9E] font-bold';

  // Define custom components for PrismicRichText
  const customRichTextComponents: JSXMapSerializer = {
    paragraph: ({ children, key }) => (
      <p key={key}>
        <StyleCharsRecursive styles={specialCharStyles}>
          {children}
        </StyleCharsRecursive>
      </p>
    ),
    heading1: ({ children, key }) => (
      <h1 key={key}>
        <StyleCharsRecursive styles={specialCharStyles}>
          {children}
        </StyleCharsRecursive>
      </h1>
    ),
    heading2: ({ children, key }) => (
      <h2 key={key}>
        <StyleCharsRecursive styles={specialCharStyles}>
          {children}
        </StyleCharsRecursive>
      </h2>
    ),
    heading3: ({ children, key }) => (
      <h3 key={key}>
        <StyleCharsRecursive styles={specialCharStyles}>
          {children}
        </StyleCharsRecursive>
      </h3>
    ),
    heading4: ({ children, key }) => (
      <h4 key={key}>
        <StyleCharsRecursive styles={specialCharStyles}>
          {children}
        </StyleCharsRecursive>
      </h4>
    ),
    heading5: ({ children, key }) => (
      <h5 key={key}>
        <StyleCharsRecursive styles={specialCharStyles}>
          {children}
        </StyleCharsRecursive>
      </h5>
    ),
    heading6: ({ children, key }) => (
      <h6 key={key}>
        <StyleCharsRecursive styles={specialCharStyles}>
          {children}
        </StyleCharsRecursive>
      </h6>
    ),
    listItem: (
      { children, key }, // For <ul>
    ) => (
      <li key={key}>
        <StyleCharsRecursive styles={specialCharStyles}>
          {children}
        </StyleCharsRecursive>
      </li>
    ),
    oListItem: (
      { children, key }, // For <ol>
    ) => (
      <li key={key}>
        <StyleCharsRecursive styles={specialCharStyles}>
          {children}
        </StyleCharsRecursive>
      </li>
    ),
  };

  // Ensure the field is not null or undefined before passing to PrismicRichText
  if (!field) {
    return null; // Or some fallback UI
  }

  // Optionally, wrap the PrismicRichText in a div if you need to apply a className to the StatHeader itself
  if (className) {
    return (
      <div className={className}>
        <PrismicRichText field={field} components={customRichTextComponents} />
      </div>
    );
  }

  return (
    <PrismicRichText field={field} components={customRichTextComponents} />
  );
};

export default StatHeader;
